function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#272727;}.b{fill:#fff;}.c,.d{fill:#bcbec0;}.c{stroke:rgba(0,0,0,0);}.e{fill:#f1f2f2;}.f{fill:#58abc8;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-284.769 -140.114)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M576.955,231.727a397.9,397.9,0,0,1,56.042-9.6,452.04,452.04,0,0,1,45.55-2.287c2.866,0,5.727.026,8.825.084,36.024.669,37.9-13.978.335-14.726-2.844-.057-6-.088-9.167-.088a465.932,465.932,0,0,0-47.034,2.364,416.922,416.922,0,0,0-54.551,9.066Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M576.955,227.928a402.889,402.889,0,0,1,55.671-9.465,457.19,457.19,0,0,1,55.074-2.218c30.937.6,31.854-6.724.056-7.363-2.982-.06-6.128-.09-9.215-.09a462,462,0,0,0-46.662,2.344,411.107,411.107,0,0,0-54.923,9.188Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M687.635,213.941a455.586,455.586,0,0,0-55.009,2.219,402.665,402.665,0,0,0-55.671,9.467v2.3a402.889,402.889,0,0,1,55.671-9.465,476.018,476.018,0,0,1,54.817-2.241l.6.01"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M423.044,231.727a397.8,397.8,0,0,0-56.04-9.6,452.08,452.08,0,0,0-45.552-2.287c-2.944,0-5.883.028-9.087.089-35.913.685-37.639-13.983-.078-14.731,2.854-.057,6.013-.088,9.177-.088a465.991,465.991,0,0,1,47.034,2.364,416.93,416.93,0,0,1,54.547,9.066Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M423.044,227.928a402.779,402.779,0,0,0-55.667-9.465,457.32,457.32,0,0,0-54.94-2.221c-30.953.59-32.317-6.687-.607-7.352,3.126-.066,6.411-.1,9.633-.1a461.976,461.976,0,0,1,46.66,2.344,411.066,411.066,0,0,1,54.921,9.188Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M312.363,213.942a455.656,455.656,0,0,1,55.014,2.218,402.556,402.556,0,0,1,55.667,9.467v2.3a402.779,402.779,0,0,0-55.667-9.465,457.18,457.18,0,0,0-55.364-2.212C281.118,216.871,281.118,214.569,312.363,213.942Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M536.41,235.124a3.853,3.853,0,0,0-3.854-3.854H500.393a3.85,3.85,0,0,0-3.85,3.854h0a3.849,3.849,0,0,0,3.85,3.849h32.163a3.852,3.852,0,0,0,3.854-3.849Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M500.393,235.124h32.163a3.834,3.834,0,0,0,3.317-1.926,3.789,3.789,0,0,1,.537,1.926,3.852,3.852,0,0,1-3.854,3.849H500.393a3.849,3.849,0,0,1-3.85-3.849,3.8,3.8,0,0,1,.534-1.926A3.832,3.832,0,0,0,500.393,235.124Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M538.262,235.124a5.713,5.713,0,0,1-5.706,5.705H500.393a5.7,5.7,0,0,1,0-11.41h32.163A5.711,5.711,0,0,1,538.262,235.124Zm-5.706,2a2,2,0,0,0,0-4H500.393a2,2,0,0,0,0,4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M536.41,200.683a3.854,3.854,0,0,0-3.854-3.853H500.393a3.851,3.851,0,0,0-3.85,3.853h0a3.848,3.848,0,0,0,3.85,3.85h32.163a3.851,3.851,0,0,0,3.854-3.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M500.393,200.683h32.163a3.838,3.838,0,0,0,3.317-1.926,3.8,3.8,0,0,1,.537,1.926,3.851,3.851,0,0,1-3.854,3.85H500.393a3.826,3.826,0,0,1-3.316-5.776A3.837,3.837,0,0,0,500.393,200.683Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M538.262,200.683a5.711,5.711,0,0,1-5.706,5.7H500.393a5.7,5.7,0,1,1,0-11.408h32.163A5.71,5.71,0,0,1,538.262,200.683Zm-5.706,2a2,2,0,0,0,0-3.993H500.393a2,2,0,0,0,0,3.993Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M603.623,226.037H572.577V209.769h31.046a7.333,7.333,0,0,1,7.335,7.333v1.6A7.334,7.334,0,0,1,603.623,226.037Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M603.623,226.037H572.577v-4.981h27.476a7.333,7.333,0,0,0,7.335-7.334v-1.6a7.36,7.36,0,0,0-.134-1.386,7.324,7.324,0,0,1,3.7,6.367v1.6A7.334,7.334,0,0,1,603.623,226.037Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M612.811,217.1v1.6a9.2,9.2,0,0,1-9.188,9.188H572.577a1.854,1.854,0,0,1-1.852-1.854V209.769a1.853,1.853,0,0,1,1.852-1.854h31.046A9.2,9.2,0,0,1,612.811,217.1Zm-38.379,7.081h29.191a5.488,5.488,0,0,0,5.481-5.48v-1.6a5.487,5.487,0,0,0-5.481-5.48H574.432Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M559.078,251.351H527.416a7.658,7.658,0,0,1-7.659-7.66V192.114a7.658,7.658,0,0,1,7.659-7.66h31.662Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 11.124,
  height: 66.897,
  transform: "translate(549.299 184.454)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M560.932,184.454v66.9a1.854,1.854,0,0,1-1.854,1.853H527.416a9.524,9.524,0,0,1-9.513-9.513V192.114a9.523,9.523,0,0,1,9.513-9.513h31.662A1.854,1.854,0,0,1,560.932,184.454Zm-3.71,65.042V186.308H527.416a5.811,5.811,0,0,0-5.807,5.806v51.577a5.812,5.812,0,0,0,5.807,5.805Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M566.025,188.056a5.762,5.762,0,0,0-5.581-5.923h0a5.761,5.761,0,0,0-5.585,5.923v59.692a5.76,5.76,0,0,0,5.585,5.923h0a5.761,5.761,0,0,0,5.581-5.923Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M560.444,253.671a5.325,5.325,0,0,1-2.8-.8,5.982,5.982,0,0,0,2.793-5.125V188.056a5.984,5.984,0,0,0-2.793-5.124,5.307,5.307,0,0,1,2.8-.8,5.762,5.762,0,0,1,5.581,5.923v59.692A5.761,5.761,0,0,1,560.444,253.671Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M567.878,188.056v59.692a7.444,7.444,0,1,1-14.873,0V188.056a7.444,7.444,0,1,1,14.873,0Zm-3.707,59.692V188.056a3.742,3.742,0,1,0-7.456,0v59.692a3.743,3.743,0,1,0,7.456,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M577.045,238.505h-11.02V197.3h11.02a6.059,6.059,0,0,1,6.061,6.057v29.089A6.059,6.059,0,0,1,577.045,238.505Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M577.045,238.505h-5.1a6.061,6.061,0,0,0,6.064-6.06V203.356a6.061,6.061,0,0,0-6.064-6.057h5.1a6.059,6.059,0,0,1,6.061,6.057v29.089A6.059,6.059,0,0,1,577.045,238.505Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M584.96,203.356v29.089a7.926,7.926,0,0,1-7.915,7.915h-11.02a1.853,1.853,0,0,1-1.854-1.855V197.3a1.854,1.854,0,0,1,1.854-1.854h11.02A7.924,7.924,0,0,1,584.96,203.356Zm-17.082,33.3h9.167a4.213,4.213,0,0,0,4.209-4.207V203.356a4.212,4.212,0,0,0-4.209-4.2h-9.167Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 13.106,
  height: 8.068,
  transform: "translate(519.757 213.869)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "e",
  width: 13.106,
  height: 4.033,
  transform: "translate(519.757 217.903)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M534.719,213.869v8.067a1.854,1.854,0,0,1-1.856,1.854H519.757a1.853,1.853,0,0,1-1.854-1.854v-8.067a1.853,1.853,0,0,1,1.854-1.855h13.106A1.855,1.855,0,0,1,534.719,213.869Zm-13.11,6.215h9.4V215.72h-9.4Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "b",
  y1: 24.882,
  transform: "translate(573.914 205.462)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M573.914,203.608a1.855,1.855,0,0,0-1.854,1.854v24.882a1.854,1.854,0,0,0,3.708,0V205.462A1.855,1.855,0,0,0,573.914,203.608Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M474.81,264.068l-14.368,14.368a1.853,1.853,0,1,0,2.62,2.621l14.371-14.367a1.854,1.854,0,0,0-2.623-2.622Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M496.865,271.661a1.853,1.853,0,0,0-1.853,1.855v20.32a1.853,1.853,0,1,0,3.706,0v-20.32A1.854,1.854,0,0,0,496.865,271.661Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M518.6,263.291a1.853,1.853,0,1,0-2.623,2.619l14.367,14.371a1.854,1.854,0,1,0,2.622-2.622Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M496.543,164.145a1.855,1.855,0,0,0,1.854-1.854V141.969a1.854,1.854,0,1,0-3.708,0v20.322A1.855,1.855,0,0,0,496.543,164.145Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M474.81,172.515a1.854,1.854,0,0,0,2.623-2.62l-14.371-14.369a1.853,1.853,0,1,0-2.62,2.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M517.285,172.282a1.863,1.863,0,0,0,1.315-.544l14.367-14.369a1.853,1.853,0,0,0-2.621-2.62l-14.369,14.369a1.854,1.854,0,0,0,1.308,3.164Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M391.066,226.037h31.045V209.769H391.066a7.333,7.333,0,0,0-7.335,7.333v1.6A7.334,7.334,0,0,0,391.066,226.037Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M391.066,226.037h31.045v-4.981H394.637a7.334,7.334,0,0,1-7.335-7.334v-1.6a7.444,7.444,0,0,1,.134-1.386,7.325,7.325,0,0,0-3.705,6.367v1.6A7.334,7.334,0,0,0,391.066,226.037Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M391.066,207.915h31.045a1.851,1.851,0,0,1,1.851,1.854v16.268a1.852,1.852,0,0,1-1.851,1.854H391.066a9.2,9.2,0,0,1-9.188-9.188v-1.6A9.2,9.2,0,0,1,391.066,207.915Zm29.191,3.707H391.066a5.487,5.487,0,0,0-5.481,5.48v1.6a5.488,5.488,0,0,0,5.481,5.48h29.191Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M417.644,238.505h11.02V197.3h-11.02a6.059,6.059,0,0,0-6.06,6.057v29.089A6.059,6.059,0,0,0,417.644,238.505Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M417.644,238.505h5.1a6.059,6.059,0,0,1-6.06-6.06V203.356a6.059,6.059,0,0,1,6.06-6.057h-5.1a6.059,6.059,0,0,0-6.06,6.057v29.089A6.059,6.059,0,0,0,417.644,238.505Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M417.644,195.445h11.02a1.854,1.854,0,0,1,1.855,1.854v41.206a1.854,1.854,0,0,1-1.855,1.855h-11.02a7.925,7.925,0,0,1-7.915-7.915V203.356A7.923,7.923,0,0,1,417.644,195.445Zm9.166,3.708h-9.166a4.211,4.211,0,0,0-4.207,4.2v29.089a4.212,4.212,0,0,0,4.207,4.207h9.166Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "b",
  y1: 24.882,
  transform: "translate(420.775 205.462)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M420.775,203.608a1.854,1.854,0,0,1,1.855,1.854v24.882a1.854,1.854,0,0,1-3.707,0V205.462A1.852,1.852,0,0,1,420.775,203.608Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M467.984,184.456H436.323a7.658,7.658,0,0,0-7.659,7.661v51.574a7.658,7.658,0,0,0,7.659,7.66h31.661Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 11.121,
  height: 66.895,
  transform: "translate(458.207 184.456)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M467.984,253.2H436.323a9.522,9.522,0,0,1-9.513-9.513V192.117a9.524,9.524,0,0,1,9.513-9.516h31.661a1.856,1.856,0,0,1,1.855,1.855v66.9A1.856,1.856,0,0,1,467.984,253.2Zm-31.661-66.9a5.813,5.813,0,0,0-5.8,5.809v51.574a5.813,5.813,0,0,0,5.8,5.807h29.806v-63.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M474.932,247.748a5.759,5.759,0,0,1-5.582,5.923h0a5.76,5.76,0,0,1-5.583-5.923V188.056a5.761,5.761,0,0,1,5.583-5.923h0a5.762,5.762,0,0,1,5.583,5.923Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M469.35,182.133a5.282,5.282,0,0,0-2.791.8,5.989,5.989,0,0,1,2.791,5.124v59.692a5.986,5.986,0,0,1-2.79,5.125,5.3,5.3,0,0,0,2.791.8,5.759,5.759,0,0,0,5.582-5.923V188.056A5.762,5.762,0,0,0,469.35,182.133Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M469.35,255.524a7.619,7.619,0,0,1-7.436-7.776V188.056a7.444,7.444,0,1,1,14.872,0v59.692A7.619,7.619,0,0,1,469.35,255.524Zm0-71.537a3.916,3.916,0,0,0-3.731,4.069v59.692a3.744,3.744,0,1,0,7.459,0l0-59.692A3.915,3.915,0,0,0,469.35,183.987Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M453.094,228.407H440.255a1.853,1.853,0,0,0,0,3.706h12.839a1.853,1.853,0,1,0,0-3.706Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M440.255,223.875h12.839a1.853,1.853,0,1,0,0-3.705H440.255a1.853,1.853,0,0,0,0,3.705Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M440.255,215.636h12.839a1.853,1.853,0,1,0,0-3.705H440.255a1.853,1.853,0,0,0,0,3.705Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M440.255,207.4h12.839a1.854,1.854,0,1,0,0-3.707H440.255a1.854,1.854,0,0,0,0,3.707Z"
}));

function SvgNoConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430.373,
    height: 155.576,
    viewBox: "0 0 430.373 155.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnectionIcon);
export default __webpack_public_path__ + "static/media/no-connection-icon.f4d1036e.svg";
export { ForwardRef as ReactComponent };